/* eslint-disable no-debugger */
import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import { isValidDate, isValidBirthDate, isValidMemberId } from '@usas/ui-web/utils/validation';
import Constants from '@usas/ui-web/utils/Constants';

export const localValidate = (formState) => {
  let errors = {};

  const hasValidStartDate = isValidDate(formState.startDate);
  const hasValidEndDate = isValidDate(formState.endDate);
  const hasValidPilotStartDate = isValidDate(formState.pilotStartDate);
  const hasValidPilotEndDate = isValidDate(formState.pilotEndDate);

  const startDate = new Date(formState.startDate);
  const endDate = new Date(formState.endDate);

  const startDateOriginal = new Date(formState.startDateOriginal);
  const endDateOriginal = new Date(formState.endDateOriginal);

  const pilotStartDate = hasValidPilotStartDate ? new Date(formState.pilotStartDate) : null;
  const pilotEndDate = hasValidPilotEndDate ? new Date(formState.pilotEndDate) : null;

  const isInPilotPeriod = hasValidStartDate
    && hasValidEndDate
    && hasValidPilotStartDate
    && hasValidPilotEndDate
    && startDate >= pilotStartDate
    && endDate <= pilotEndDate;

  //Meet Name`
  if (formState.meetName.trim() === '') {
    errors.meetName = 'Meet Name is required';
  } else if ((formState.autogeneratedMeetYear + ' ' + formState.autogeneratedMeetOrg + ' ' + formState.meetName.trim()).toString().length > 200) {
    errors.meetName = 'Meet Name cannot exceed 200 characters';
  }

  //Meet Announcement
  // const meetAnnouncementUrl = formState.meetAnnouncementUrl || '';
  // if (meetAnnouncementUrl.trim() === '' || meetAnnouncementUrl.includes('Bad Request')) {
  //   errors.meetAnnouncementUrl = 'Meet Announcement file is required';
  // }

  //Meet Classification
  if (formState.meetClassification.length === 0) {
    errors.meetClassification = 'Meet Classification is required';
  }

  //Meet Course
  if (formState.meetCourse.length === 0) {
    errors.meetCourse = "Must pick at least one Course";
  }

  //Start Date
  if (formState.startDate === Constants.BLANK_DATE_STRING) {
    errors.startDate = 'Start Date is required';
  } else if (!isValidDate(formState.startDate)) {
    errors.startDate = 'Start Date must be a valid date';
  } else if (isValidBirthDate(formState.startDate) && startDate.getTime() !== startDateOriginal.getTime()) {
    errors.startDate = 'Start Date cannot be in the past if you are changing it from the original date';
  } else if (endDate < startDate && formState.startDate !== formState.endDate) {
    errors.startDate = 'Start Date must be before the End Date';
  }

  //End Date
  if (formState.endDate === Constants.BLANK_DATE_STRING) {
    errors.endDate = 'End Date is required';
  } else if (!isValidDate(formState.endDate)) {
    errors.endDate = 'End Date must be a valid date';
  } else if (isValidBirthDate(formState.endDate) && endDate.getTime() !== endDateOriginal.getTime()) {
    errors.endDate = 'End Date cannot be in the past if you are changing it from the original date';
  } else if (endDate < startDate && formState.startDate !== formState.endDate) {
    errors.endDate = 'End Date must be after the Start Date';
  }

  if (formState.status === 'Paid') {
    const diffInMs = endDate - startDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24) + 1;

    const diffInMsOriginal = endDateOriginal - startDateOriginal;
    const diffInDaysOriginal = diffInMsOriginal / (1000 * 60 * 60 * 24) + 1;

    if (diffInDays != diffInDaysOriginal) {
      errors.startDate = 'Cannot change meet duration after payment';
    }
  }

  // Meet Duration
  if (hasValidStartDate && hasValidEndDate && endDate >= startDate) {
    const diffInMs = endDate - startDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24) + 1;
    if (diffInDays > 9) {
      errors.endDate = 'Meet cannot be longer than 9 days';
    }
  }

  //Meet Software
  if (formState.meetSoftwareId <= 0) {
    errors.meetSoftwareId = 'Meet Management Software is required';
  }

  //Meet Format
  if (formState.meetFormatId <= 0) {
    errors.meetFormatId = 'Meet Format is required';
  }

  //Payor Member Id
  if (formState.payorMemberId === undefined || formState.payorMemberId.trim() === '') {
    errors.payorMemberId = 'Payor Member Id is required';
  } else if (!isValidMemberId(formState.payorMemberId.trim())) {
    errors.payorMemberId = 'Payor Member Id must be 14 alphanumeric characters';
  }

  //Facility
  if (formState.facilityId <= 0) {
    errors.facilityId = 'Facility is required';
  }

  if (formState.attestationSignature.trim() === '') {
    errors.attestationSignature = 'Attestation Signature is required';
  }

  if (!hasValidPilotStartDate || !hasValidPilotEndDate) {
    if (!errors.startDate) {
      errors.startDate = 'Pilot configuration dates are unavailable. Please refresh and try again.';
    }
  } else if (hasValidStartDate && hasValidEndDate) {
    if (isInPilotPeriod && !(formState.facilityName || '').toLowerCase().includes('wi')) {
      errors.facilityId = 'Facility must be in Wisconsin for USAS Sanctioned Meets during the WI pilot program (Sept 2026 - Aug 2027)';
    } else if (!isInPilotPeriod && !errors.startDate) {
      errors.startDate = `Meet Start Date must be between ${formState.pilotStartDate} and ${formState.pilotEndDate} to apply for USAS Sanctioning during the WI pilot program`;
    }
  }

  if (formState.competitionType === 'Open' && (!formState.openTypeAsApprovedMeetReason || formState.openTypeAsApprovedMeetReason.trim() === '')) {
    errors.openTypeAsApprovedMeetReason = 'Open Type as Approved Meet Reason is required';
  }

  return errors;
};

const serverValidate = async (formState) => {
  let errors = {};

  //Meet Sanction Payor
  const payorMemberIdForUrl = formState.payorMemberId ? encodeURIComponent(formState.payorMemberId) : 'NaN';
  await PersonHttpHelper(`/Person/flat/memberId/${payorMemberIdForUrl}`, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      }
      else {
        if (objData.isOrgRoleDurationActive === false || !(objData.personId)) {
          errors.payorMemberId = "Payor Member Id does not have an active member registration";
        } else {
          formState.payorPersonId = objData.personId;
        }
      }
    })
    .catch(() => {
      errors.payorMemberId = 'Payor Member Id is not valid';
    });

  return errors;
};

const MeetApprovedInfoFormValidation = async (formState) => {
  let errors = localValidate(formState);
  if (!errors || Object.keys(errors).length === 0) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
};

export default MeetApprovedInfoFormValidation;